<template>
  <qx-auto-complete v-model="supplierValue"
                    :disabled="disabled"
                    :fetch-suggestions="supplierSearch"
                    :orderDefaultValue="defaultValue"
                    @select="selectItem"
                    value-key="code"
                    placeholder="请选择纱线"/>
</template>

<script>
  /**
   * @description 纱线推荐搜索组件
   * @author: 菩萨蛮
   * @date 2020/2/26 3:44 上午
   * @version V1.0.0
   *
   * 公司的业务千篇一律，复杂的代码好几百行
   */
  import AutoComplete from '../../../mixins/common/AutoComplete';


  export default {
    name: 'YarnAutoComplete',
    mixins: [AutoComplete],
    data() {
      return {
        url: '/base/info/yarn?pageSize=5&pageNum=0&code=',
        itemName: 'code'
      };
    }
  };
</script>

<style lang="scss" scoped>

</style>
